import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Col, Row, Divider, Descriptions, Tag, Typography, Spin } from "antd";
import { driverService } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";

function ViewDriver() {
    const { id } = useParams();
    const [driver, setDriver] = useState(null);
    const [loading, setLoading] = useState(false);

    const driverDetails = [
        { label: "Address", value: driver?.address },
        { label: "Country", value: driver?.country_name },
        { label: "Phone", value: driver?.phone },
        { label: "Status", value: <Tag color={driver?.isActive === 1 ? "green" : "red"}>{driver?.isActive === 1 ? "Active" : "Inactive"}</Tag> },
    ];


    const initialize = async () => {
        setLoading(true);
        const { success, data } = await driverService.view(id);
        setLoading(false);
        if (success) {
            setDriver(data);
        }
    };

    useEffect(() => {
        changeDocumentTitle("View Driver");
        initialize();
    }, []);

    return (
        <>
            {loading
                ? <div className="flex justify-center min-w-full min-h-[50vh] items-center">
                    <Spin spinning={loading} size={"large"} tip="Loading..." />
                </div>
                :
                <div
                    style={{
                        padding: "0 14px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#FFFFFF",
                        paddingBottom: "20px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginRight: "auto",
                            marginLeft: "auto",
                            padding: "10px",
                            borderRadius: "8px",
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        {/* Round Image */}
                        <div
                            style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                marginBottom: "15px",
                                marginRight: "auto",
                                marginLeft: "auto",
                            }}
                        >
                            <img
                                src="/images/empview.png"
                                alt="User"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        </div>

                        {/* Name */}
                        <Typography.Title level={3} style={{ marginBottom: 0 }}>
                            {driver?.name}
                        </Typography.Title>

                        {/* Email */}
                        <Typography.Title level={5} style={{ marginBottom: 0 }}>
                            {driver?.email}
                        </Typography.Title>

                    </div>
                    <Divider />
                    <Row gutter={24}>
                        <Col span={24}>
                            <Descriptions
                                bordered
                                column={1}
                                size="middle"
                                labelStyle={{ width: '20%', backgroundColor: '#f5f5f5' }}
                                contentStyle={{ width: '80%' }}
                            >
                                {driverDetails.map((item, index) => (
                                    <Descriptions.Item label={item.label} key={index}>
                                        {item.value}
                                    </Descriptions.Item>
                                ))}
                            </Descriptions>
                        </Col>

                    </Row>
                </div>
            }

        </>
    );
}

export default ViewDriver;
